import { buildCsvString } from '../../ui/data-table/components/table-export/csv-utils';
import type { RosterColumn } from './roster.columns';

/**
 * The Roster CSV: the columns the user has visible, in their order, over the given rows.
 *
 * Escaping and formula-injection guarding come from the shared `csv-utils` — a provider named
 * `=HYPERLINK(…)` downloads as text, not as a live formula.
 *
 * What can reach the file is bounded by the column set: `ROSTER_*_COLUMNS` has no SSN column,
 * and ops-only columns are absent for a client admin, so neither can be exported whatever the
 * picker says. That is deliberate — the export must not widen what the table shows.
 *
 * `textOf` is the display text of a cell, so the file matches the screen (a place-of-service
 * code rather than the raw enum, for instance).
 */
export function buildRosterCsv<T>(
    columns: RosterColumn[],
    records: T[],
    textOf: (record: T, key: string) => string,
): string {
    const headers = columns.map(column => column.label);
    const rows = records.map(record => {
        const row: Record<string, unknown> = {};
        columns.forEach(column => {
            row[column.label] = textOf(record, column.key);
        });
        return row;
    });
    return buildCsvString(rows, headers);
}

export function rosterCsvFilename(tab: string, now: Date): string {
    return `enter-roster-${tab}-${now.toISOString().slice(0, 10)}.csv`;
}
